const dataGames = [
    {
        id: 1,
        name: "NfS Heat (PS5)",
        description: "Need for Speed Heat ist ein rasanten und spannenden Rennspielen, was sich in einer offenen Welt namens Palm City abspielt.",
        image: "nfs",
        price: 25,
        category: 'PlayStation',
    },
    {
        id: 2,
        name: "Spyro Reignited Trilogy (PS4)",
        description: "Der Meister der Flammen ist zurück! Wie immer ist er Feuer und Flamme, und jetzt brennt er auf neue Abenteuer in atemberaubendem HD.",
        image: "spyro",
        price: 15,
        category: 'PlayStation',
    },
    {
        id: 3,
        name: "Minecraft (PS3)",
        description: "Entdecke zufällig generierte Welten und baue Unglaubliches, von einem einfachen Zuhause bis hin zu riesigen Schlössern.",
        image: "minecr",
        price: 10,
        category: 'PlayStation',
    },
    {
        id: 4,
        name: "Sonic Frontiers (X-Box Series X/S)",
        description: "Im neuesten rasanten Abenteuer von Sonic the Hedgehog prallen Welten aufeinander! Kämpfe gegen Horden mächtiger Gegner und erkunde eine atemberaubende Welt voller Action, Abenteuer und Geheimnisse.",
        image: "sonic",
        price: 35,
        category: 'X-Box',
    },
    {
        id: 5,
        name: "Halo Wars 2 (X-Box One)",
        description: "In dem Echtzeit-Strategiespiel Halo Wars 2, wo Sie als Spartans, Warthogs oder mit anderen Einheiten in einen brutalen Kampf gegen einen furchteinflößenden Feind führen.",
        image: "halo",
        price: 9,
        category: 'X-Box',
    },
    {
        id: 6,
        name: "Street Fighter X Tekken (X-Box 360)",
        description: "Street Fighter X Tekken liefert das ultimative Tag-Team-Match und schickt die beliebtesten Charaktere beider Serien in den Ring.",
        image: "street",
        price: 5,
        category: 'X-Box',
    },
    {
        id: 7,
        name: "Dragon Ball (Switch)",
        description: "DRAGON BALL: THE BREAKERS ist ein asymmetrisches Online-Actionspiel, in dem eine Gruppe aus sieben ganz normalen Menschen versucht, gegen den Räuber zu überleben der sie jagt und zu einer unaufhaltsamen Kraft heranwächst.",
        image: "dragonball",
        price: 18,
        category: 'Nintendo',
    },
    {
        id: 8,
        name: "New Super Mario Bros. U (Wii U)",
        description: "Mit New Super Mario Bros. U erscheint der neueste Titel der beliebten Jump’n‘Run-Serie In dem neuen Abenteuer nimmt Mario immer neue Gestalten an und die Spieler können in Form ihrer Mii-Charaktere mitmischen!",
        image: "supermario",
        price: 15,
        category: 'Nintendo',
    },
    {
        id: 9,
        name: "Mario Kart Wii (Wii)",
        description: "Mario Kart Wii ist ein Rennspiel voller Action, in dem die Spieler ihre liebsten Nintendo-Charaktere auswählen und auf Karts oder Motorrädern an Rennen oder Wettkämpfen teilnehmen können.",
        image: "mariokart",
        price: 11,
        category: 'Nintendo',
    },
];

export default dataGames;